import carLogo from './red-buggy-car.svg';
import weather1 from './01.png';
import weather2 from './02.png';
import weather3 from './03.png';
import weather4 from './04.png';
import weather5 from './05.png';
import weather6 from './06.png';
import weather7 from './07.png';
import weather8 from './08.png';
import weather11 from './11.png';
import weather12 from './12.png';
import weather13 from './13.png';
import weather14 from './14.png';
import weather15 from './15.png';
import weather16 from './16.png';
import weather17 from './17.png';
import weather18 from './18.png';
import weather19 from './19.png';
import weather20 from './20.png';
import weather21 from './21.png';
import weather22 from './22.png';
import weather23 from './23.png';
import weather24 from './24.png';
import weather25 from './25.png';
import weather26 from './26.png';
import weather29 from './29.png';
import weather30 from './30.png';
import weather31 from './31.png';
import weather32 from './32.png';
import weather33 from './33.png';
import weather34 from './34.png';
import weather35 from './35.png';
import weather36 from './36.png';
import weather37 from './37.png';
import weather38 from './38.png';
import weather39 from './39.png';
import weather40 from './40.png';
import weather41 from './41.png';
import weather42 from './42.png';
import weather43 from './43.png';
import weather44 from './44.png';

export default {
    carLogo,
    weather1,
    weather2,
    weather3,
    weather4,
    weather5,
    weather6,
    weather7,
    weather8,
    weather11,
    weather12,
    weather13,
    weather14,
    weather15,
    weather16,
    weather17,
    weather18,
    weather19,
    weather20,
    weather21,
    weather22,
    weather23,
    weather24,
    weather25,
    weather26,
    weather29,
    weather30,
    weather31,
    weather32,
    weather33,
    weather34,
    weather35,
    weather36,
    weather37,
    weather38,
    weather39,
    weather40,
    weather41,
    weather42,
    weather43,
    weather44,
}
